import CopyManagementRegimesModal from './CopyManagementRegimesModal'

export default CopyManagementRegimesModal
